
import { defineComponent } from 'vue';
import { mapState } from 'pinia';
import { useAuthStore } from '~app/core/auth';
import { useConfigStore } from '~app/core/config';

export default defineComponent({
  name: 'menu-products',
  computed: {
    ...mapState(useAuthStore, {
      products: 'currentUserProducts',
    }),
    ...mapState(useConfigStore, {
      features: 'features',
    }),
  },
});
